<template>
    <div class="accountsReceivableStatistics">
        <navBar :extr="navData"></navBar>
        <div :class="{ accountsReceivableStatistics_content: !getIsLh(), accountsReceivableStatistics_content_lh: getIsLh()}">
            <div class="search-box">
                <van-field
                    label="期次"
                    v-model="queryDate.report_month"
                    placeholder="请输入"
                    clickable
                    readonly
                    @click="reportMonthBlur"
                ></van-field>
                <van-field
                    label="账龄"
                    v-model="queryDate.account_age"
                    placeholder="请输入"
                    clickable
                    readonly
                    right-icon="cross"
                    @click="accountAgeBlur"
                    @click-right-icon.stop="delAccountAge"
                ></van-field>
                <van-field
                    label="关键字"
                    v-model="queryDate.search_key"
                    placeholder="请输入"
                    right-icon="search"
                    @click-right-icon="searchKeyBlur"
                ></van-field>
            </div>
            <table class="accountsReceivableStatistics_table">
                <thead>
                    <tr>
                        <td colspan="1" rowspan="2" style="width: 40px;">
                            序号
                        </td>
                        <td colspan="1" rowspan="2" style="width: 80px;">
                            填报单位全称
                        </td>
                        <td colspan="1" rowspan="2" style="width: 80px;">
                            对方单位名称
                        </td>
                        <td colspan="3" style="width: 200px;">
                            上月情况
                        </td>
                        <td colspan="3" style="width: 200px;">
                            本月情况
                        </td>
                        <td rowspan="2" style="width: 80px;">
                            账款类别
                        </td>
                        <td rowspan="2" style="width: 80px;">
                            账龄
                        </td>
                        <td rowspan="2" style="width: 80px;">
                            已实施的措施
                        </td>
                        <td rowspan="2" style="width: 80px;">
                            下一步工作计划
                        </td>
                        <td rowspan="2" style="width: 50px;">
                            是否已提起诉讼
                        </td>
                        <td rowspan="2" style="width: 80px;">
                            诉讼进度
                        </td>
                        <td rowspan="2" style="width: 80px;">
                            催收工作具体责任人
                        </td>
                    </tr>
                    <tr>
                        <td>原值</td>
                        <td>坏账准备</td>
                        <td>账面价值</td>
                        <td>原值</td>
                        <td>坏账准备</td>
                        <td>账面价值</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,index) in tableList" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.report_dept_name }}</td>
                        <td>{{ item.opposite_dept_name }}</td>
                        <td>{{ item.original_value_last }}</td>
                        <td>{{ item.bad_debt_reserves_last }}</td>
                        <td>{{ item.book_value_last }}</td>
                        <td>{{ item.original_value_curr }}</td>
                        <td>{{ item.bad_debt_reserves_curr }}</td>
                        <td>{{ item.book_value_curr }}</td>
                        <td>{{ item.account_type }}</td>
                        <td>{{ item.account_age }}</td>
                        <td>{{ item.account_age }}</td>
                        <td>{{ item.next_step_work_plan }}</td>
                        <td>{{ item.litigated }}</td>
                        <td>{{ item.litigation_progress }}</td>
                        <td>{{ item.collection_person }}</td>
                    </tr>
                    <tr class="sum">
                        <td>合计</td>
                        <td>{{ totalData.report_dept_name }}</td>
                        <td>{{ totalData.opposite_dept_name }}</td>
                        <td>{{ totalData.original_value_last }}</td>
                        <td>{{ totalData.bad_debt_reserves_last }}</td>
                        <td>{{ totalData.book_value_last }}</td>
                        <td>{{ totalData.original_value_curr }}</td>
                        <td>{{ totalData.bad_debt_reserves_curr }}</td>
                        <td>{{ totalData.account_type }}</td>
                        <td>{{ totalData.account_age }}</td>
                        <td>{{ totalData.account_age }}</td>
                        <td>{{ totalData.next_step_work_plan }}</td>
                        <td>{{ totalData.litigated }}</td>
                        <td>{{ totalData.litigation_progress }}</td>
                        <td>{{ totalData.collection_person }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="picker" v-if="isShowReportMonth || isShowAccountAge">
            <van-datetime-picker
                v-if="isShowReportMonth"
                v-model="reportMonth"
                type="year-month"
                title="选择期次"
                @confirm="onReportMonthConfirm"
                @cancel="isShowReportMonth = false"
            ></van-datetime-picker>
            <van-picker
                v-if="isShowAccountAge"
                title="账龄"
                show-toolbar
                :columns="columns"
                @confirm="onAccountAgeConfirm"
                @cancel="onAccountAgeCancel"
            ></van-picker>
        </div>
    </div>
</template>

<script>
import currencyFun from '@/assets/js/currencyFun/index.js';
import navBar from '@/components/navBarBox/landscapeScreen';
export default {
    name: 'shi-mo-mobile-spherical-cost-estimation',
    components: {
        navBar,
    },
    data() {
        return {
            navData: {
                title: '应收账款统计表（鸡西）',
                leftArrow: true,
            },
            tableCode: '',
            tableHeader: [],
            tableList: [],
            queryDate: {
                account_age: '',
                search_key: '',
            },
            totalData: {},
            columns: ['1年以内', '1-3年', '3年以下', '3-5年', '5-8年', '8-10年', '10年以上'],
            isShowAccountAge: false,
            isShowReportMonth: false,
            reportMonth: new Date(),
        };
    },
    created() {
        // 参数 0横向 1竖向
        window.$globalHub.$callMobile('JYTeamsNative', 'setScreenOrientation', 0);
    },

    mounted() {
        this.init();
    },

    methods: {
        async init() {
            this.tableCode = this.$route.query.tableCode;
            this.queryDate.report_month = currencyFun.timeFormat(new Date(), 'yyyy-LL');
            this.fetchData();
        },
        // 编辑初始化列表数据
        getDataApi() {
            const path = '/interfaceApi/report/accounts_receivable/get_list';
            return this.$axios.$post(path, this.queryDate, { defEx: true });
        },
        // 获取列表数据
        async fetchData() {
            const res = await this.getDataApi();
            this.tableList = res || [];
            // this.total = res.total;
            this.loading = false;
            this.getTotal();
        },
        // 获取合计数据
        async getTotal() {
            const url = '/interfaceApi/report/accounts_receivable/get_total_data';
            this.totalData = await this.$axios.$post(url, this.queryDate, { defEx: true });
        },
        // 获取合计数据
        getSummaries({ columns }) {
            const sums = [];
            columns.forEach((column, index) => {
                sums[index] = this.totalData[column.property] ?? '';
            });
            sums[0] = '合计';
            return sums;
        },
        onAccountAgeConfirm(e) {
            this.queryDate.account_age = e;
            this.isShowAccountAge = false;
            this.fetchData();
        },
        onAccountAgeCancel(e) {
            this.isShowAccountAge = false;
        },
        // 点击期次
        reportMonthBlur() {
            this.isShowReportMonth = true;
            this.isShowAccountAge = false;
        },
        // 点击账龄
        accountAgeBlur() {
            this.isShowAccountAge = true;
            this.isShowReportMonth = false;
        },
        onReportMonthConfirm(e) {
            this.queryDate.report_month = currencyFun.timeFormat(e, 'yyyy-MM');
            this.isShowReportMonth = false;
            this.fetchData();
        },
        delAccountAge() {
            this.queryDate.account_age = '';
            this.isShowAccountAge = false;
            this.fetchData();
        },
        // 点击关键词搜索
        searchKeyBlur() {
            this.fetchData();
        },
        getIsLh() {
            return localStorage.getItem('jy_navbarHeight') ? true : false;
        },
    },
    beforeDestroy() {
        window.$globalHub.$callMobile('JYTeamsNative', 'setScreenOrientation', 1);
    },
};
</script>

<style lang="stylus" scoped>
.accountsReceivableStatistics {
    width: 100vw!important;
    height: 100vh!important;
    position relative;
    box-sizing: border-box;
    &_content {
        width: calc(100vw - 7.6vw);
        height: 100vh;
        overflow: scroll;
        position absolute;
        top: 0;
        left: 7.5vw;
    }
    &_content_lh {
        width: calc(100vw - 11.6vw);
        height: 100vh;
        overflow: scroll;
        position absolute;
        top: 0;
        left: 11.5vw;
    }
    .search-box {
        width: 300rpx;
        display: flex;
        margin-top: 1.6vw;
    }
    &_table {
        width: 100%;
        height: 100%;
        border: 1px solid #ccc;
        border-collapse: collapse;
        font-size: 1.2vw
        table-layout: fixed;
        background: #F9FBFF;
        thead {
            font-weight: 700
            background: #e6eaf2
        }
        td {
            border: 1px solid #ccc;
            text-align: center;
            padding: 10px;
            word-wrap: no-wrap;
        }
        tbody {
            position relative;
        }
    }
    .picker {
        width: 93vw
        height: 100rpx
        position:absolute
        bottom: 0
        left 7vw
    }
}
</style>

